import { WeaponConfig } from '../types';

export const WEAPONS: Record<string, WeaponConfig> = {
  pistol: {
    id: 'pistol',
    name: 'Pistol',
    nameKey: 'weapon.pistol',
    damage: 15,
    fireRate: 4,
    magazineSize: 12,
    reloadTime: 1.5,
    range: 30,
    spread: 0.01,
    pellets: 1,
    isExplosive: false,
    explosionRadius: 0,
    isAutomatic: false,
    price: 0,
  },
  shotgun: {
    id: 'shotgun',
    name: 'Shotgun',
    nameKey: 'weapon.shotgun',
    damage: 8,
    fireRate: 1.2,
    magazineSize: 6,
    reloadTime: 2.5,
    range: 15,
    spread: 0.08,
    pellets: 6,
    isExplosive: false,
    explosionRadius: 0,
    isAutomatic: false,
    price: 500,
  },
  smg: {
    id: 'smg',
    name: 'SMG',
    nameKey: 'weapon.smg',
    damage: 10,
    fireRate: 12,
    magazineSize: 30,
    reloadTime: 2.0,
    range: 25,
    spread: 0.03,
    pellets: 1,
    isExplosive: false,
    explosionRadius: 0,
    isAutomatic: true,
    price: 800,
  },
  rocketLauncher: {
    id: 'rocketLauncher',
    name: 'Rocket Launcher',
    nameKey: 'weapon.rocketLauncher',
    damage: 150,
    fireRate: 0.5,
    magazineSize: 1,
    reloadTime: 3.0,
    range: 50,
    spread: 0,
    pellets: 1,
    isExplosive: true,
    explosionRadius: 5,
    isAutomatic: false,
    price: 2000,
  },
  assaultRifle: {
    id: 'assaultRifle',
    name: 'Assault Rifle',
    nameKey: 'weapon.assaultRifle',
    damage: 22,
    fireRate: 8,
    magazineSize: 25,
    reloadTime: 2.2,
    range: 45,
    spread: 0.02,
    pellets: 1,
    isExplosive: false,
    explosionRadius: 0,
    isAutomatic: true,
    price: 3000,
  },
  grenade: {
    id: 'grenade',
    name: 'Grenade',
    nameKey: 'weapon.grenade',
    damage: 120,
    fireRate: 0.8,
    magazineSize: 3,
    reloadTime: 0,
    range: 20,
    spread: 0,
    pellets: 1,
    isExplosive: true,
    explosionRadius: 6,
    isAutomatic: false,
    price: 300,
  },
};
